module.exports = __webpack_public_path__ + "img/loading-spinner.f65b0044.svg";